export const formFields = [
  {
    section: "Details",
    name: "opcScheduleName",
    label: "Schedule",
    fieldLabel: "OPC Schedule Name",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 10, message: "MAXLENGTH_10" },
    },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [1, 1],
  },
  {
    section: "Details",
    name: "opcDescription",
    label: "Description",
    fieldLabel: "OPC Description",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 40, message: "MAXLENGTH_40" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [2, 1],
  },
  {
    section: "Details",
    name: "opcDispOutdatedRcds",
    label: "Display",
    fieldLabel: "DSC Disp Outdated Rcds?",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [3, 1],
  },
  {
    section: "Details",
    name: "opcBasis",
    label: "Basis",
    fieldLabel: "OPC Basis",
    type: "dropdown",
    dropdownCondition: "*Valid Values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [4, 1],
  },
  {
    section: "Details",
    name: "opcStepCount",
    label: "Steps",
    fieldLabel: "Wrk Number",
    type: "number",
    options: {},
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [5, 1],
  },
  {
    section: "Details",
    name: "planCode",
    label: "Member Override Plan",
    fieldLabel: "Plan Code",
    type: "lookup",
    externalProgram: { default: "RCPLN018" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          { source: "planCode", target: "planCode",legacy:"planCode" },
          { source: "planEffDate", 
            resolver:"formatDateForPresto",
            legacy:"planEffDate",
            target: "planEffDate" },
          { source: "planName", target: "planName",legacy:"planName" },
        ],
      },
      appName: "ACCUMS",
      pageName: "PLAN_CODE",
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [6, 1],
  },
  {
    section: "Details",
    name: "planName",
    label: "",
    fieldLabel: "Plan Name",
    type: "text",
    options: { maxLength: { value: 25, message: "MAXLENGTH_25" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [6, 2],
  },
  {
    section: "Details",
    name: "planEffDate",
    label: "Plan From Date",
    fieldLabel: "Plan From Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [7, 1],
  },
  {
    section: "Details",
    name: "opcMbrFromDateSwitch",
    label: "Member From Date Based On",
    fieldLabel: "OPC Mbr From Date Switch",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 1],
  },
  {
    section: "Details",
    name: "opcMbrFromDate",
    label: "Date",
    fieldLabel: "OPC Mbr From Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 3],
  },
  {
    section: "Details",
    name: "opcMbrThruDateSwitch",
    label: "Member Thru Date Based On",
    fieldLabel: "OPC Mbr Thru Date Switch",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 1],
  },
  {
    section: "Details",
    name: "opcMbrThruDaysAdded",
    label: "+ Days",
    fieldLabel: "OPC Mbr Thru Days Added",
    type: "number",
    options: {
      optional: true,
      min: { value: 0, message: "Minimum value is 0" },
      max: { value: 99999, message: "Maximum value is 99999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 2],
  },
  {
    section: "Details",
    name: "opcMbrThruDate",
    label: "Date",
    fieldLabel: "OPC Mbr Thru Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 3],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [10, 1],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [10, 2],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [10, 3],
  },
  {
    section: "Audit Fields",
    name: "noteExistenceStatus",
    label: "Note Exists",
    fieldLabel: "Note Existence Status",
    type: "text",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [10, 4],
  },
];
